import { useState } from "react";
import {
  DisableiIcon,
  EnableiIcon,
  RedCheckIcon,
  VerifyIcon,
  WhiteCheckIcon,
} from "../../../../assets/images";
import {
  PanVerifyType,
  TanVerifyType,
} from "../../../../redux/services/serviceTypes";
import {
  isPanValid,
  isTanValid,
  returnInputFieldLength,
} from "../../../../utils/commonFunctions";
import { RollingLoader } from "../../../commons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
type AppProps = {
  registrationsDetails: any;
  handleRegistrationsDetailsChange: (data: any) => void;
  clientAadharUniqueCheckFetching: boolean;
  clientPanUniqueCheckFetching: boolean;
  clientAadharUniqueCheckMessage: string | null;
  clientPanUniqueCheckMessage: string | null;
  isDisabled?: boolean;
  getPanDetails: (data: any) => void;
  getTanDetails: (data: any) => void;
  panVerifyDetails: PanVerifyType | null;
  tanVerifyDetails: TanVerifyType | null;
  singleClientDirectory: any;
};
const RegistrationDetails = ({
  registrationsDetails,
  clientAadharUniqueCheckFetching,
  clientPanUniqueCheckFetching,
  handleRegistrationsDetailsChange,
  clientAadharUniqueCheckMessage,
  clientPanUniqueCheckMessage,
  isDisabled,
  getPanDetails,
  getTanDetails,
  panVerifyDetails,
  tanVerifyDetails,
  singleClientDirectory,
}: AppProps) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <>
      <h5>Registrations</h5>
      <span className="mb-3">Update your registration details here</span>
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="pan">PAN</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                className={`form-control ${
                  clientPanUniqueCheckMessage?.includes(
                    "PAN number already exists"
                  )
                    ? "error-border"
                    : ""
                }`}
                name="pan"
                value={registrationsDetails?.pan}
                onChange={handleRegistrationsDetailsChange}
                maxLength={10}
                disabled={isDisabled}
              />
              <span
                className="position-absolute"
                style={{ top: "7px", right: "5px" }}
              >
                {(registrationsDetails?.panDetails?.status === "VALID" &&
                  registrationsDetails?.pan?.length === 10) ||
                (singleClientDirectory?.registration_details &&
                  singleClientDirectory?.registration_details?.pan_details
                    ?.status === "VALID" &&
                  singleClientDirectory?.registration_details?.pan ===
                    registrationsDetails?.pan &&
                  registrationsDetails?.pan?.length === 10) ? (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-filter-invoice">
                        <div>
                          <div className="text-left">
                            Full Name :{" "}
                            {registrationsDetails?.panDetails?.full_name
                              ? registrationsDetails?.panDetails?.full_name
                              : singleClientDirectory?.registration_details
                                  ?.pan_details?.full_name
                              ? singleClientDirectory?.registration_details
                                  ?.pan_details?.full_name
                              : "NA"}
                          </div>
                          <div className="text-left">
                            PAN No :{" "}
                            {registrationsDetails?.panDetails?.pan
                              ? registrationsDetails?.panDetails?.pan
                              : singleClientDirectory?.registration_details
                                  ?.pan_details?.pan
                              ? singleClientDirectory?.registration_details
                                  ?.pan_details?.pan
                              : "NA"}
                          </div>
                          <div className="text-left">
                            Category :{" "}
                            {registrationsDetails?.panDetails?.category
                              ? registrationsDetails?.panDetails?.category
                              : singleClientDirectory?.registration_details
                                  ?.pan_details?.category
                              ? singleClientDirectory?.registration_details
                                  ?.pan_details?.category
                              : "NA"}
                          </div>
                          <div className="text-left">
                            Status :{" "}
                            {registrationsDetails?.panDetails?.status
                              ? registrationsDetails?.panDetails?.status
                              : singleClientDirectory?.registration_details
                                  ?.pan_details?.status
                              ? singleClientDirectory?.registration_details
                                  ?.pan_details?.status
                              : "NA"}
                          </div>
                        </div>
                      </Tooltip>
                    }
                  >
                    <img src={EnableiIcon} />
                  </OverlayTrigger>
                ) : (
                  <img src={DisableiIcon} />
                )}
              </span>
              {clientPanUniqueCheckFetching && registrationsDetails?.pan && (
                <RollingLoader />
              )}
            </div>
            {(registrationsDetails?.panDetails?.status === "VALID" &&
              registrationsDetails?.pan?.length === 10) ||
            (singleClientDirectory?.registration_details &&
              singleClientDirectory?.registration_details?.pan_details
                ?.status === "VALID" &&
              singleClientDirectory?.registration_details?.pan ===
                registrationsDetails?.pan &&
              registrationsDetails?.pan?.length === 10) ? (
              <span>
                <img src={VerifyIcon} alt="pan" />{" "}
                <span style={{ color: "#28a745" }}>PAN is Verified</span>
              </span>
            ) : panVerifyDetails?.status === "INVALID" ? (
              <span className="text-danger">PAN is Invalid</span>
            ) : (
              <span className="input-length">
                {returnInputFieldLength(registrationsDetails?.pan?.length, 10)}
              </span>
            )}
            <div>
              <span className="text-danger" style={{ fontSize: "12px" }}>
                {!isPanValid(
                  registrationsDetails?.pan?.length > 0
                    ? registrationsDetails?.pan
                    : ""
                ) &&
                  !!registrationsDetails?.pan?.length && (
                    <span>PAN not valid</span>
                  )}
              </span>
            </div>
            <div>
              <span className="text-danger" style={{ fontSize: "12px" }}>
                {clientPanUniqueCheckMessage?.includes(
                  "PAN number already exists"
                ) && <span>PAN number already exists</span>}
              </span>
            </div>
          </div>
        </div>
        <div className="col-md-2 mt-2">
          <div className="form-group mt-3">
            <button
              className="btn btn-outline"
              disabled={
                (registrationsDetails?.pan &&
                registrationsDetails?.pan?.length > 9
                  ? false
                  : true) ||
                (registrationsDetails?.pan?.length &&
                  !isPanValid(
                    registrationsDetails?.pan?.length
                      ? registrationsDetails?.pan?.trim()
                      : ""
                  ))
              }
              onClick={(e) => {
                getPanDetails(e);
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <img
                src={isHovered ? WhiteCheckIcon : RedCheckIcon}
                alt="check"
              />{" "}
              <span>Verify</span>
            </button>
          </div>
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-md-3">
          <form>
            <div
              className="form-group position-relative"
              style={{ marginBottom: "0px" }}
            >
              <label htmlFor="tan">TAN</label>
              <input
                type="text"
                name="tan"
                className={`form-control`}
                value={registrationsDetails?.tan}
                onChange={handleRegistrationsDetailsChange}
                disabled={isDisabled}
                maxLength={10}
              />
              <span
                className="position-absolute"
                style={{ top: "30px", right: "5px" }}
              >
                {(tanVerifyDetails?.nameOrgn?.length &&
                  registrationsDetails?.tan?.length === 10) ||
                (singleClientDirectory?.registration_details &&
                  singleClientDirectory?.registration_details?.tan_details
                    ?.nameOrgn?.length &&
                  singleClientDirectory?.registration_details?.tan ===
                    registrationsDetails?.tan &&
                  registrationsDetails?.tan?.length === 10) ? (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-filter-invoice">
                        <div>
                          <div className="text-left">
                            <span>Full Name :</span>{" "}
                            <span className="branch">
                              {tanVerifyDetails?.nameOrgn
                                ? tanVerifyDetails?.nameOrgn
                                : singleClientDirectory?.registration_details
                                    ?.tan_details?.nameOrgn
                                ? singleClientDirectory?.registration_details
                                    ?.tan_details?.nameOrgn
                                : null}
                            </span>
                          </div>
                          <div className="text-left">
                            <span>Address Line 1 :</span>{" "}
                            <span className="micr">
                              {tanVerifyDetails?.addLine1
                                ? tanVerifyDetails?.addLine1
                                : singleClientDirectory?.registration_details
                                    ?.tan_details?.addLine1
                                ? singleClientDirectory?.registration_details
                                    ?.tan_details?.addLine1
                                : null}
                            </span>
                          </div>
                          <div className="text-left">
                            <span>Address Line 2 :</span>{" "}
                            <span className="micr">
                              {tanVerifyDetails?.addLine2
                                ? tanVerifyDetails?.addLine2
                                : singleClientDirectory?.registration_details
                                    ?.tan_details?.addLine2
                                ? singleClientDirectory?.registration_details
                                    ?.tan_details?.addLine2
                                : null}
                            </span>
                          </div>
                          <div className="text-left">
                            <span>Address Line 3 :</span>{" "}
                            <span className="micr">
                              {tanVerifyDetails?.addLine3
                                ? tanVerifyDetails?.addLine3
                                : singleClientDirectory?.registration_details
                                    ?.tan_details?.addLine3
                                ? singleClientDirectory?.registration_details
                                    ?.tan_details?.addLine3
                                : null}
                            </span>
                          </div>
                          <div className="text-left">
                            <span>Address Line 5 :</span>{" "}
                            <span className="micr">
                              {tanVerifyDetails?.addLine5
                                ? tanVerifyDetails?.addLine5
                                : singleClientDirectory?.registration_details
                                    ?.tan_details?.addLine5
                                ? singleClientDirectory?.registration_details
                                    ?.tan_details?.addLine5
                                : null}
                            </span>
                          </div>
                          <div className="text-left">
                            <span>PIN :</span>{" "}
                            <span className="micr">
                              {tanVerifyDetails?.pin
                                ? tanVerifyDetails?.pin
                                : singleClientDirectory?.registration_details
                                    ?.tan_details?.pin
                                ? singleClientDirectory?.registration_details
                                    ?.tan_details?.pin
                                : null}
                            </span>
                          </div>
                          <div className="text-left">
                            <span>Phone Number :</span>{" "}
                            <span className="micr">
                              {tanVerifyDetails?.phoneNum
                                ? tanVerifyDetails?.phoneNum
                                : singleClientDirectory?.registration_details
                                    ?.tan_details?.phoneNum
                                ? singleClientDirectory?.registration_details
                                    ?.tan_details?.phoneNum
                                : null}
                            </span>
                          </div>
                          <div className="text-left">
                            <span>Email :</span>{" "}
                            <span className="micr">
                              {tanVerifyDetails?.emailId1
                                ? tanVerifyDetails?.emailId1
                                : singleClientDirectory?.registration_details
                                    ?.tan_details?.emailId1
                                ? singleClientDirectory?.registration_details
                                    ?.tan_details?.emailId1
                                : null}
                            </span>
                          </div>
                        </div>
                      </Tooltip>
                    }
                  >
                    <img src={EnableiIcon} />
                  </OverlayTrigger>
                ) : (
                  <img src={DisableiIcon} />
                )}
              </span>
            </div>
            {(tanVerifyDetails?.nameOrgn?.length &&
              registrationsDetails?.tan?.length === 10) ||
            (singleClientDirectory?.registration_details &&
              singleClientDirectory?.registration_details?.tan_details?.nameOrgn
                ?.length &&
              singleClientDirectory?.registration_details?.tan ===
                registrationsDetails?.tan &&
              registrationsDetails?.tan?.length === 10) ? (
              <span>
                <img src={VerifyIcon} alt="tan" />{" "}
                <span style={{ color: "#28a745" }}>TAN is Verified</span>
              </span>
            ) : tanVerifyDetails?.messages[0]?.desc === "No record found" ? (
              <span className="text-danger">No record found</span>
            ) : (
              <span className="input-length">
                {returnInputFieldLength(registrationsDetails?.tan?.length, 10)}
              </span>
            )}
          </form>
        </div>
        <div className="col-md-2 mt-4">
          <div className="form-group">
            <button
              className="btn btn-outline"
              disabled={
                (registrationsDetails?.tan &&
                registrationsDetails?.tan?.length > 9
                  ? false
                  : true) ||
                (registrationsDetails?.tan?.length &&
                  !isTanValid(
                    registrationsDetails?.tan?.length
                      ? registrationsDetails?.tan?.trim()
                      : ""
                  ))
              }
              onClick={(e) => {
                getTanDetails(e);
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <img
                src={isHovered ? WhiteCheckIcon : RedCheckIcon}
                alt="check"
              />{" "}
              <span>Verify</span>
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group">
              <label htmlFor="corporateIdOfTheCompany">
                Corporate ID of the Company
              </label>
              <input
                type="text"
                name="corporateIdOfTheCompany"
                className={`form-control ${false ? "error-border" : null}`}
                value={registrationsDetails?.corporateIdOfTheCompany}
                onChange={(e) => handleRegistrationsDetailsChange(e)}
                disabled={isDisabled}
              />
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group">
              <label htmlFor="directorOfPartnerId">
                Director of Partner ID
              </label>
              <input
                type="text"
                className={`form-control`}
                name="directorOfPartnerId"
                value={registrationsDetails?.directorOfPartnerId}
                onChange={handleRegistrationsDetailsChange}
                disabled={isDisabled}
              />
            </div>
          </form>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group">
              <label htmlFor="tin">TIN</label>
              <input
                type="text"
                className={`form-control`}
                name="tin"
                value={registrationsDetails?.tin}
                onChange={handleRegistrationsDetailsChange}
                disabled={isDisabled}
                // onChange={(e) => handleShippingAddressChange("constitutionOfBusiness", e.target.value, i)}
              />
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group">
              <label htmlFor="serviceTaxNumber">Service Tax Number</label>
              <input
                type="text"
                className={`form-control`}
                name="serviceTaxNumber"
                value={registrationsDetails?.serviceTaxNumber}
                onChange={handleRegistrationsDetailsChange}
                disabled={isDisabled}
                // value={item["companyStatus"] || ""}
                // onChange={(e) => handleShippingAddressChange("companyStatus", e.target.value, i)}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default RegistrationDetails;
